"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertNumToChinese = void 0;
var index_1 = require("../constant/index");
/**
 * 获得中文数字字典
 * @param type 选择大小写的类型
 */
function getChineseNumberString(type) {
    if (type === index_1.NumberLanguageCaseType.ChineseLowerCase) {
        return index_1.LowerChineseNumberString;
    }
    if (type === index_1.NumberLanguageCaseType.ChineseUpperCase) {
        return index_1.UpperChineseNumberString;
    }
    return null;
}
/**
 * 获得需要补齐的前导 0, 例如输入 '00123' 需要将前面的 0 补齐
 * @param oldNumberString 原始输入数字字符
 * @param newNumberString 转数字后再转回字符的数字字符串
 * @param paddingChar 待填充的字符串
 * @param opts 可选参数
 */
function getPaddingZeros(oldNumberString, paddingChar, options) {
    if (!(options === null || options === void 0 ? void 0 : options.fill)) {
        return '';
    }
    var paddingString = '';
    // 匹配前导 0
    var paddingMatchResult = oldNumberString.match(/^[+-]?(0*)[\d]+/);
    if (!paddingMatchResult) {
        return '';
    }
    // 获得前导 0 长度
    var paddingLength = paddingMatchResult[1].length;
    // 判断字符串是支持 padStart 函数, 若无则常规添加
    if (paddingString.padStart) {
        paddingString += paddingString.padStart(paddingLength, paddingChar);
    }
    else {
        paddingString += new Array(paddingLength).fill(paddingChar).join('');
    }
    return paddingString;
}
/**
 * 整数部分转换时判断是否需要显示前面的一
 * @param index 当前数字字符串下标
 * @param currentChar 当前数字字符
 * @param cnRadiceIndex 当前十百千单位下标
 * @param options 其他选项
 */
function isShowingFirstIntegerOne(index, currentChar, cnRadiceIndex, options) {
    // 不为首位可以显示
    if (index !== 0) {
        return true;
    }
    // 该位不为 1 或者单位不为 十
    if (currentChar !== '1' || cnRadiceIndex !== 1) {
        return true;
    }
    // 选项存在且选择项不显示首位的 1
    if (options === null || options === void 0 ? void 0 : options.showTenOne) {
        return true;
    }
    return false;
}
/**
 * 是否需要添加万, 亿, 兆单位
 * @param zeroCount 前面出现的 0 的个数
 * @param cnRadiceIndex 当前十百千单位下标
 * @param options 其他选项
 */
function isAddingUnit(zeroCount, cnRadiceIndex, options) {
    // 如果未出现在万, 亿, 兆单位位置处则不加
    if (cnRadiceIndex !== 0) {
        return false;
    }
    // 如果该位前的 0 的个数大于 4则不加
    if (zeroCount >= 4) {
        return false;
    }
    // 若选择项明确声明不显示单位则不加
    if (!options || !options.unit) {
        return false;
    }
    return true;
}
/**
 * 将整数部分字符串进行转换
 * @param integerNumber 待转换整数
 * @param chineseNumberString 中文数字列表
 * @param options 其他选项
 */
function getIntegerPart(integerNumber, chineseNumberString, options) {
    var resultChineseString = '';
    // 解构中文数字单位
    var cnNums = chineseNumberString.cnNums, cnIntRadice = chineseNumberString.cnIntRadice, cnIntUnits = chineseNumberString.cnIntUnits;
    // 为 0 直接返回
    if (parseInt(integerNumber, 10) === 0) {
        resultChineseString += cnNums[0];
        return resultChineseString;
    }
    // 获取整型部分转换
    var zeroCount = 0;
    var intLength = integerNumber.length;
    for (var index = 0; index < intLength; index++) {
        var currentChar = integerNumber.substr(index, 1);
        var digit = intLength - index - 1;
        var cnUnitsIndex = digit / 4;
        var cnRadiceIndex = digit % 4;
        if (currentChar === '0') {
            if (options && !options.unit) {
                // 如果没有单位的话, 挨个取值
                resultChineseString += cnNums[parseInt(currentChar, 10)];
            }
            else {
                zeroCount += 1;
            }
        }
        else {
            if (zeroCount > 0) {
                resultChineseString += cnNums[0];
                // 归零
                zeroCount = 0;
            }
            // 处理第一位数字
            if (isShowingFirstIntegerOne(index, currentChar, cnRadiceIndex, options)) {
                // 只针对第一个数字, 例如 一十就不需要显示一了, 直接显示十
                resultChineseString += cnNums[parseInt(currentChar, 10)];
            }
            // 判断是否显示单位
            if (options === null || options === void 0 ? void 0 : options.unit) {
                resultChineseString += cnIntRadice[cnRadiceIndex];
            }
        }
        // 添加万, 亿, 兆单位
        if (isAddingUnit(zeroCount, cnRadiceIndex, options)) {
            resultChineseString += cnIntUnits[cnUnitsIndex];
        }
    }
    return resultChineseString;
}
/**
 * 将小数部分字符串进行转换
 * @param decimalNumber 待转换小数
 * @param cnNums 中文数字
 */
function getDecimalPart(decimalNumber, cnNums) {
    var resultChineseString = '';
    var clonedDecimalNumber = decimalNumber;
    if (decimalNumber && decimalNumber !== '' && Number(decimalNumber) !== 0) {
        // 小数部分
        var decimalLength = decimalNumber.length;
        if (decimalLength > 0) {
            // 存在小数点
            resultChineseString += '.';
        }
        for (var index = 0; index < decimalLength; index++) {
            var currentChar = clonedDecimalNumber.substr(index, 1);
            resultChineseString += cnNums[Number(currentChar)];
        }
    }
    return resultChineseString;
}
/**
 * 转换数字为中文
 * @param number 待转换的数字
 * @param type 要转换的类型 目前只支持1中文小写 2中文大写
 * @param options 可选参数
 *            opts.fill 要不要补充前导0
 *            opts.unit 是否按单位计算还是挨个换算  如果为false 1900 就翻译成一九○○  如果为true 则翻译成 一千九百
 *            opts.showTenOne 当数字开头是一十X兆/亿/万/十的时候要不要显示前面的一 默认隐藏
 */
function convertNumToChinese(number, type, options) {
    // 输入为空直接返回
    if (number === '') {
        return '';
    }
    // 根据类型选择中文大小写
    var chineseNumberString = getChineseNumberString(type);
    // 类型未命中不做转换
    if (!chineseNumberString) {
        return number;
    }
    // 获得中文数字
    var cnNums = chineseNumberString.cnNums;
    // 最大处理的数字
    var maxNumber = 999999999999999.9999;
    // 金额整数部分
    var integerNumber = '';
    // 金额小数部分
    var decimalNumber = '';
    // 输出的中文金额字符串
    var chineseString = '';
    // 分离金额后用的数组，预定义
    var parts;
    var floatNum = parseFloat(number);
    if (floatNum >= maxNumber) {
        // TODO: 超出最大数字，暂时直接返回原值，后面再改造
        return number;
    }
    // 转换为字符串
    var convertedNumberString = floatNum.toString();
    // 补充可能的前导 0
    chineseString += getPaddingZeros(number, cnNums[0], options);
    // 为 0 直接返回
    if (floatNum === 0) {
        chineseString += cnNums[0];
        return chineseString;
    }
    // 提取负号
    if (floatNum < 0) {
        chineseString += '-';
        convertedNumberString = convertedNumberString.substr(1);
    }
    // 分割小数部分和整数部分
    if (convertedNumberString.indexOf('.') === -1) {
        integerNumber = convertedNumberString;
    }
    else {
        parts = convertedNumberString.split('.');
        integerNumber = parts[0], decimalNumber = parts[1];
    }
    // 转换整数部分
    chineseString += getIntegerPart(integerNumber, chineseNumberString, options);
    // 转换小数部分
    chineseString += getDecimalPart(decimalNumber, cnNums);
    if (chineseString === '') {
        return cnNums[0];
    }
    return chineseString;
}
exports.convertNumToChinese = convertNumToChinese;
//# sourceMappingURL=language-format-utils.js.map